import React from 'react';

class Flag extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            country: props.country,
            flag: props.flag,
        };
    }
  
    render() {
        return(
            <div className="flag-container">
            <img
              src={this.props.flag}
              alt="flag"
            />
          </div>
        );
    }
  }
export default Flag;